export default "__VITE_ASSET__BKwbbFXK__"